/** trim to largest */
function updateUnderline(heading) {
  const range = document.createRange()
  let maxWidth = 0

  function processNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      const lines = node.textContent.split('\n')
      lines.forEach((line) => {
        range.setStart(node, 0)
        range.setEnd(node, line.length)
        const rect = range.getBoundingClientRect()
        if (rect.width > maxWidth) {
          maxWidth = rect.width
        }
      })
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      const style = window.getComputedStyle(node)
      if (style.display === 'none') {
        // Für display: none Elemente, temporär sichtbar machen und messen
        const originalDisplay = node.style.display
        node.style.display = 'inline'
        node.style.visibility = 'hidden'
        node.style.position = 'absolute'
        Array.from(node.childNodes).forEach(processNode)
        node.style.display = originalDisplay
        node.style.visibility = ''
        node.style.position = ''
      } else if (node.tagName === 'BR' || node.classList.contains('title-break')) {
        // Behandle Zeilenumbrüche
        maxWidth = Math.max(maxWidth, measurePreviousContent(node))
      } else {
        Array.from(node.childNodes).forEach(processNode)
      }
    }
  }

  function measurePreviousContent(node) {
    const tempRange = document.createRange()
    tempRange.setStartBefore(heading)
    tempRange.setEndBefore(node)
    return tempRange.getBoundingClientRect().width
  }

  processNode(heading)

  // Runde auf ganze Pixel
  const roundedWidth = Math.round(maxWidth)
  heading.style.setProperty('--underline-width', `${roundedWidth}px`)
  // console.log('Set --underline-width to:', `${roundedWidth}px`)
}

// Der Rest des Codes bleibt unverändert
function initializeUnderlines() {
  document.querySelectorAll('.underline-heading').forEach(updateUnderline)
}

function debounce(func, wait) {
  let timeout
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

const debouncedResize = debounce(() => {
  document.querySelectorAll('.underline-heading').forEach(updateUnderline)
}, 250)

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeUnderlines)
} else {
  initializeUnderlines()
}
window.addEventListener('resize', debouncedResize)
